/**
 * New Expedient
 * Expedient for Student Account
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The InlineObject1 model module.
 * @module model/InlineObject1
 * @version 1.0
 */
class InlineObject1 {
    /**
     * Constructs a new <code>InlineObject1</code>.
     * @alias module:model/InlineObject1
     * @param file {File} 
     * @param academicProgramId {Number} 
     * @param payedAt {Date} 
     */
    constructor(file, academicProgramId, payedAt) { 
        
        InlineObject1.initialize(this, file, academicProgramId, payedAt);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, file, academicProgramId, payedAt) { 
        obj['file'] = file;
        obj['academic_program_id'] = academicProgramId;
        obj['payed_at'] = payedAt;
    }

    /**
     * Constructs a <code>InlineObject1</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/InlineObject1} obj Optional instance to populate.
     * @return {module:model/InlineObject1} The populated <code>InlineObject1</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new InlineObject1();

            if (data.hasOwnProperty('file')) {
                obj['file'] = ApiClient.convertToType(data['file'], File);
            }
            if (data.hasOwnProperty('academic_program_id')) {
                obj['academic_program_id'] = ApiClient.convertToType(data['academic_program_id'], 'Number');
            }
            if (data.hasOwnProperty('payed_at')) {
                obj['payed_at'] = ApiClient.convertToType(data['payed_at'], 'Date');
            }
        }
        return obj;
    }


}

/**
 * @member {File} file
 */
InlineObject1.prototype['file'] = undefined;

/**
 * @member {Number} academic_program_id
 */
InlineObject1.prototype['academic_program_id'] = undefined;

/**
 * @member {Date} payed_at
 */
InlineObject1.prototype['payed_at'] = undefined;






export default InlineObject1;

